import type { SVGProps } from "react";
const SvgHelpQuestionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 25"
    fontSize="1rem"
    {...props}
  >
    <g fill="#CE3B4D">
      <path d="M12.561 13.717c0 .426.007.844-.002 1.262a.65.65 0 0 1-.589.63.664.664 0 0 1-.729-.697q-.002-.903 0-1.808c.002-.43.271-.697.708-.7.487-.004.975.025 1.444-.16.954-.374 1.577-1.36 1.474-2.356-.106-1.034-.904-1.886-1.912-2.041-1.101-.17-2.09.324-2.504 1.282a2.9 2.9 0 0 0-.193.844c-.042.426-.3.707-.699.692-.381-.014-.636-.31-.63-.732.023-1.833 1.59-3.386 3.454-3.423 1.878-.038 3.382 1.135 3.75 2.923.408 1.982-1.047 3.977-3.087 4.233-.15.019-.3.032-.485.051M12.844 16.944c.005.438-.368.804-.824.811s-.843-.348-.854-.783c-.01-.45.369-.822.838-.823.456-.001.836.359.84.795" />
    </g>
    <circle cx={12.5} cy={12.5} r={11.75} stroke="#CE3B4D" strokeWidth={1.5} />
  </svg>
);
export default SvgHelpQuestionIcon;
